import type { StoryblokRichTextDoc } from '~/.storyblok/types/storyblok';

export const EMPTY_RICHTEXT: StoryblokRichTextDoc = { type: 'doc', content: [] };
